var render = function render(){
  var _vm$order, _vm$preview, _vm$preview2, _vm$order$verified_re, _vm$order$verified_re2, _vm$order$verified_re3, _vm$showGiftcardBlobP, _vm$showGiftcardBlobP2, _vm$showGiftcardBlobP3, _vm$claimGiftcardMerc, _vm$_b, _vm$order2, _vm$order2$skin;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.claimGiftcardStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.replyStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _vm.$route.hash == '#add-to-calendar' && (_vm$order = _vm.order) !== null && _vm$order !== void 0 && _vm$order.event ? _c('add-to-calendar-dialog', {
    attrs: {
      "event": _vm.order.event,
      "value": true
    },
    on: {
      "input": function ($event) {
        return _vm.$router.replace(Object.assign({}, _vm.$route, {
          hash: undefined
        }));
      }
    }
  }) : _vm._e(), _vm.isInvitation && (_vm.$route.hash == '#rsvp' || _vm.showRSVP) ? _c('form-rsvp-recipient-dialog', {
    attrs: {
      "token": _vm.readToken || ((_vm$preview = _vm.preview) === null || _vm$preview === void 0 ? void 0 : _vm$preview.read_token),
      "order": _vm.order,
      "preview": _vm.preview,
      "value": true
    },
    on: {
      "input": function () {
        _vm.showRSVP = false;
        if (_vm.showRSVPAsIntercept) _vm.close(true);else if (_vm.$route.hash == '#rsvp') _vm.$router.replace(Object.assign({}, _vm.$route, {
          hash: undefined
        }));
      }
    }
  }) : _vm._e(), _c('sign-in-dialog', {
    ref: "sign-in",
    model: {
      value: _vm.showSignIn,
      callback: function ($$v) {
        _vm.showSignIn = $$v;
      },
      expression: "showSignIn"
    }
  }), _vm.showPrint ? _c('print-dialog', {
    attrs: {
      "token": _vm.readToken || ((_vm$preview2 = _vm.preview) === null || _vm$preview2 === void 0 ? void 0 : _vm$preview2.read_token)
    },
    model: {
      value: _vm.showPrint,
      callback: function ($$v) {
        _vm.showPrint = $$v;
      },
      expression: "showPrint"
    }
  }) : _vm._e(), _vm.groupVideoBlob ? _c('group-video-playback', {
    attrs: {
      "dialog": "",
      "mode": "open",
      "project-id": _vm.groupVideoProjectId
    },
    on: {
      "slow-playback": _vm.onSlowPlayback,
      "play-video": _vm.pauseMusic
    },
    model: {
      value: _vm.showGroupVideo,
      callback: function ($$v) {
        _vm.showGroupVideo = $$v;
      },
      expression: "showGroupVideo"
    }
  }) : _vm._e(), _vm.showReply ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    on: {
      "input": function ($event) {
        return _vm.close(true);
      }
    },
    model: {
      value: _vm.showReply,
      callback: function ($$v) {
        _vm.showReply = $$v;
      },
      expression: "showReply"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        return _vm.close(true);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), !_vm.order.skin.disable_reply ? [_c('v-card-title', [_vm._v("Respond to sender" + _vm._s(_vm.isGroupSigned ? 's' : ''))]), _c('v-card-subtitle', [_vm._v("Send a message back to the " + _vm._s(_vm.isGroupSigned ? 'people' : 'person') + " who made you this card")]), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "counter": "5000",
      "outlined": "",
      "placeholder": "Thanks for the card",
      "rules": [function (v) {
        return (v || '').length <= 5000 || 'Message is too long';
      }],
      "disabled": !!(_vm.order.sample || _vm.order.state == 'PENDING' || (_vm$order$verified_re = _vm.order.verified_recipient) !== null && _vm$order$verified_re !== void 0 && _vm$order$verified_re.reply || _vm.replyStatus.pending),
      "value": _vm.order.sample || _vm.order.state == 'PENDING' ? 'Response disabled for test orders' : _vm.order.verified_recipient.reply || _vm.replyMsg
    },
    on: {
      "input": function (v) {
        return _vm.replyMsg = v;
      }
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !!(!_vm.replyMsg || _vm.replyMsg.length > 5000 || (_vm$order$verified_re2 = _vm.order.verified_recipient) !== null && _vm$order$verified_re2 !== void 0 && _vm$order$verified_re2.reply),
      "loading": _vm.replyStatus.pending
    },
    on: {
      "click": _vm.reply
    }
  }, [(_vm$order$verified_re3 = _vm.order.verified_recipient) !== null && _vm$order$verified_re3 !== void 0 && _vm$order$verified_re3.reply ? [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiSendCheck)
    }
  }), _vm._v("Message sent ")] : [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiSend)
    }
  }), _vm._v("Send message ")]], 2)], 1)], 1), _c('v-divider')] : _vm._e(), _c('v-card-title', [_vm._v("Share your card on social media?")]), _c('v-card-text', [_c('social-share-btns', {
    staticClass: "fill-width",
    staticStyle: {
      "max-width": "320px"
    },
    attrs: {
      "title": "My card on Ellacard",
      "description": "Check out this card I got sent on Ellacard",
      "url": `https://ellacard.com/open/${_vm.readToken}`
    }
  })], 1), _c('v-card-text', {
    staticClass: "d-flex justify-end"
  }, [_c('v-btn', {
    on: {
      "click": function ($event) {
        return _vm.close(true);
      }
    }
  }, [_vm._v("Close")])], 1), !_vm.hideReplyDetails ? [_c('v-divider'), _c('div', {
    staticClass: "grey lighten-4 py-3 px-6 caption"
  }, [_vm._v(" Verify your email address or phone number to see all the cards you've ever been sent in "), _c('router-link', {
    attrs: {
      "to": {
        name: 'account'
      }
    }
  }, [_vm._v("your Ellacard account")]), _vm._v(". ")], 1)] : _vm._e()], 2)], 1) : _vm._e(), _vm.showSelectMerchant ? _c('giftcard-recipient-choice-dialog', {
    attrs: {
      "amt": _vm.showGiftcardBlob.giftcard.amt,
      "currency": _vm.showGiftcardBlob.giftcard.cur,
      "default-country": _vm.USER_COUNTRY
    },
    on: {
      "input": function (v) {
        _vm.claimGiftcardMerchant = v || _vm.claimGiftcardMerchant;
        _vm.showSelectMerchant = false;
      }
    }
  }) : _vm._e(), _vm.showGiftcardBlob && _vm.mode == 'view' ? _c('dialog-scroll-lock-loader', {
    attrs: {
      "width": "400",
      "value": !!_vm.showGiftcardBlob,
      "loading": _vm.loadGiftcardStatus.pending
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', {
    staticClass: "pa-4"
  }, [_vm._v("Claim gift card")]), _c('v-divider'), _c('div', {
    staticClass: "pa-4"
  }, [!_vm.isRecipientChoice(_vm.showGiftcardBlob.giftcard) ? [_c('v-card', {
    staticClass: "mx-auto",
    staticStyle: {
      "border-radius": "8px",
      "max-width": "268px"
    }
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 337 / 212.5,
      "src": _vm.showGiftcardBlob.giftcard.product_img
    }
  })], 1), _c('div', {
    staticClass: "mb-4 mt-1 overline short text-center"
  }, [_vm._v(_vm._s(_vm.showGiftcardBlob.giftcard.product_name))])] : _vm._e(), _c('div', {
    staticClass: "d-flex align-center justify-center text-h3 primary--text"
  }, [_c('currency', {
    staticClass: "grey--text text-body-1",
    attrs: {
      "code": _vm.showGiftcardBlob.giftcard.cur
    }
  }), _vm._v(_vm._s(_vm.preview && !_vm.isOwner && _vm.showGiftcardBlob.user_id != _vm.globalUserId && _vm.order.skin.hide_giftcard_totals ? 'XX' : _vm.showGiftcardBlob.giftcard.amt) + " ")], 1)], 2), !_vm.showGiftcardBlob.giftcard.claim_id && !_vm.order.verified_recipient && !_vm.isRecipientChoice(_vm.showGiftcardBlob.giftcard) && !(((_vm$showGiftcardBlobP = _vm.showGiftcardBlobProduct) === null || _vm$showGiftcardBlobP === void 0 ? void 0 : _vm$showGiftcardBlobP.countries) || []).includes(_vm.USER_COUNTRY) ? _c('v-card-text', {
    staticClass: "warning--text px-4 pb-4"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This gift card cannot be used in your country: " + _vm._s(_vm.getCountryName(_vm.USER_COUNTRY)) + " ")], 1) : _vm._e(), _c('v-divider'), _c('div', {
    staticClass: "pa-4"
  }, [_vm.showGiftcardBlob.giftcard.claim_id ? _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This gift card has already been claimed. ")], 1) : !_vm.order.verified_recipient ? _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" This gift card can only be claimed using a verified private link. ")], 1) : [_c('div', {
    staticClass: "mb-4"
  }, [_vm.isRecipientChoice(_vm.showGiftcardBlob.giftcard) ? [_vm._v(" Select a merchant and enter your email address to claim this gift card. ")] : !_vm.showGiftcardBlobProduct ? [_vm._v(" This gift card could not be found (inventory may have changed since it was purchased). Please select an alternate merchant and enter your email address to continue. ")] : !(((_vm$showGiftcardBlobP2 = _vm.showGiftcardBlobProduct) === null || _vm$showGiftcardBlobP2 === void 0 ? void 0 : _vm$showGiftcardBlobP2.countries) || []).includes(_vm.USER_COUNTRY) ? [_vm._v(" Please choose an option and enter your email address to continue. "), _c('v-radio-group', {
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.merchantOpt,
      callback: function ($$v) {
        _vm.merchantOpt = $$v;
      },
      expression: "merchantOpt"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": `Use this gift card in ${_vm.getCountryName(_vm.showGiftcardBlob.giftcard.country)}`,
      "value": 0
    },
    on: {
      "click": function ($event) {
        _vm.claimGiftcardMerchant = Object.assign({}, _vm.showGiftcardBlobProduct, {
          country: _vm.showGiftcardBlob.giftcard.country
        });
      }
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Select alternate country / merchant…",
      "value": 1
    },
    on: {
      "click": function () {
        var _vm$showGiftcardBlob, _vm$showGiftcardBlob2;
        _vm.showSelectMerchant = true;
        if (_vm.claimGiftcardMerchant && ((_vm$showGiftcardBlob = _vm.showGiftcardBlob) === null || _vm$showGiftcardBlob === void 0 ? void 0 : _vm$showGiftcardBlob.giftcard.src) == _vm.claimGiftcardMerchant.src && ((_vm$showGiftcardBlob2 = _vm.showGiftcardBlob) === null || _vm$showGiftcardBlob2 === void 0 ? void 0 : _vm$showGiftcardBlob2.giftcard.product_id) == _vm.claimGiftcardMerchant.id) _vm.claimGiftcardMerchant = null;
      }
    }
  })], 1)] : [_vm._v(" Enter your email address to claim this gift card. ")]], 2), _c('v-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.claimGiftcard.apply(null, arguments);
      }
    },
    model: {
      value: _vm.claimGiftcardValid,
      callback: function ($$v) {
        _vm.claimGiftcardValid = $$v;
      },
      expression: "claimGiftcardValid"
    }
  }, [!_vm.showGiftcardBlobProduct || _vm.isRecipientChoice(_vm.showGiftcardBlob.giftcard) || _vm.USER_COUNTRY != _vm.showGiftcardBlob.giftcard.country ? _c('v-text-field', {
    class: {
      'mt-n3 ml-8': _vm.showGiftcardBlobProduct && !_vm.isRecipientChoice(_vm.showGiftcardBlob.giftcard) && !(((_vm$showGiftcardBlobP3 = _vm.showGiftcardBlobProduct) === null || _vm$showGiftcardBlobP3 === void 0 ? void 0 : _vm$showGiftcardBlobP3.countries) || []).includes(_vm.USER_COUNTRY)
    },
    attrs: {
      "name": "merchant",
      "label": "Merchant",
      "readonly": "",
      "rules": [function (v) {
        return !!v;
      }],
      "value": (_vm$claimGiftcardMerc = _vm.claimGiftcardMerchant) === null || _vm$claimGiftcardMerc === void 0 ? void 0 : _vm$claimGiftcardMerc.name
    },
    on: {
      "click": function ($event) {
        _vm.showSelectMerchant = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function () {
        var _vm$showGiftcardBlobP4;
        return [!_vm.claimGiftcardMerchant ? _c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function ($event) {
              _vm.showSelectMerchant = true;
            }
          }
        }, [_c('v-icon', {
          domProps: {
            "innerHTML": _vm._s(_vm.mdiChevronRight)
          }
        })], 1) : _vm.claimGiftcardMerchant && (!(((_vm$showGiftcardBlobP4 = _vm.showGiftcardBlobProduct) === null || _vm$showGiftcardBlobP4 === void 0 ? void 0 : _vm$showGiftcardBlobP4.countries) || []).includes(_vm.USER_COUNTRY) || _vm.claimGiftcardMerchant.country != _vm.USER_COUNTRY) ? _c('country-flag', {
          staticClass: "my-n1",
          attrs: {
            "country": _vm.claimGiftcardMerchant.country
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "append-outer",
      fn: function () {
        return [_vm.claimGiftcardMerchant ? _c('v-btn', {
          staticClass: "pa-0 gc-border",
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.showSelectMerchant = true;
            }
          }
        }, [_c('v-img', {
          staticClass: "gc-border",
          attrs: {
            "aspect-ratio": 337 / 212.5,
            "src": _vm.claimGiftcardMerchant.img
          }
        })], 1) : _vm._e()];
      },
      proxy: true
    }], null, false, 3782717004)
  }) : _vm._e(), _c('v-text-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Email address",
      "hide-details": "",
      "rules": [function (v) {
        return !!(v && _vm.EMAIL_REGEX.test(v));
      }]
    },
    model: {
      value: _vm.claimGiftcardEmail,
      callback: function ($$v) {
        _vm.claimGiftcardEmail = $$v;
      },
      expression: "claimGiftcardEmail"
    }
  })], 1), _c('v-card-text', {
    staticClass: "mt-6 pa-0 warning--text"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "small": "",
      "color": "warning"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiAlert)
    }
  }), _vm._v(" Please use a "), _c('i', [_vm._v("personal")]), _vm._v(" email address to ensure the redemption instructions do not get blocked by corporate firewalls ")], 1)]], 2), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showGiftcardBlob = null;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !!_vm.showGiftcardBlob.giftcard.claim_id || !_vm.order.verified_recipient || !_vm.claimGiftcardValid,
      "loading": _vm.claimGiftcardStatus.pending
    },
    on: {
      "click": _vm.claimGiftcard
    }
  }, [_vm._v(" Claim ")])], 1)], 1)], 1) : _vm._e(), _vm.showGiftcardBlob && _vm.mode == 'edit' ? _c('giftcard-add-dialog', {
    attrs: {
      "order-id": _vm.readToken,
      "blob": _vm.showGiftcardBlob,
      "locked": !_vm.editable,
      "max-value": _vm.maxAddGiftcardValue
    },
    on: {
      "input": function ($event) {
        _vm.showGiftcardBlob = null;
        _vm.load(true);
      }
    }
  }) : _vm._e(), _vm.showGiftcards ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.showGiftcards,
      callback: function ($$v) {
        _vm.showGiftcards = $$v;
      },
      expression: "showGiftcards"
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right mt-3 mr-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.showGiftcards = false;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Gift cards")]), _c('v-card-subtitle', {
    staticClass: "pt-4"
  }, [_vm._v("This order contains " + _vm._s(_vm.giftcardBlobs.length == 1 ? 'a gift card' : _vm.giftcardBlobs.length + ' gift cards') + ". Click on " + _vm._s(_vm.giftcardBlobs.length == 1 ? 'it' : 'a gift card') + " to claim it.")]), _c('v-divider'), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-row', [_vm._l(_vm.giftcardBlobs, function (blob) {
    return [_c('v-col', {
      staticStyle: {
        "position": "relative"
      },
      attrs: {
        "cols": "6"
      }
    }, [_c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticStyle: {
        "position": "absolute",
        "top": "8px",
        "left": "8px",
        "transition": "unset",
        "z-index": "2"
      },
      attrs: {
        "rounded": "",
        "dark": "",
        "color": blob.giftcard.claim_id ? 'grey lighten-1' : 'green lighten-2'
      },
      on: {
        "click": function ($event) {
          _vm.showGiftcardBlob = blob;
        }
      }
    }, [_c('currency', {
      attrs: {
        "code": blob.giftcard.cur
      }
    }), _vm._v(_vm._s(_vm.preview && !_vm.isOwner && blob.user_id != _vm.globalUserId && _vm.order.skin.hide_giftcard_totals ? '' : blob.giftcard.amt) + " ")], 1), _c('v-card', {
      staticClass: "ml-4 mt-4",
      staticStyle: {
        "border-radius": "8px",
        "z-index": "1"
      },
      attrs: {
        "hover": ""
      },
      on: {
        "click": function ($event) {
          _vm.showGiftcardBlob = blob;
        }
      }
    }, [_c('v-img', {
      attrs: {
        "aspect-ratio": 337 / 212.5,
        "src": blob.giftcard.product_img
      }
    })], 1)], 1)];
  })], 2)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showGiftcards = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1) : _vm._e(), _c(_vm.block ? 'div' : _vm.DialogScrollLock, _vm._b({
    tag: "component",
    attrs: {
      "transition": "",
      "fullscreen": "",
      "persistent": "",
      "no-click-animation": "",
      "value": true
    }
  }, 'component', (_vm$_b = {}, _vm$_b[_vm.block ? 'class' : 'content-class'] = 'fill-height white relative overflow-hidden', _vm$_b), false), [_vm.loadStatus.pending ? _c('div', {
    staticClass: "fill-height d-flex justify-center align-center",
    staticStyle: {
      "z-index": "1"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm.order ? _c('div', _vm._g({
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    staticClass: "fill-height d-flex flex-column relative overflow-hidden",
    style: {
      'background-color': _vm.order.skin.page_background_color,
      'cursor': _vm.isOpen ? null : 'pointer'
    }
  }, _vm.isOpen || _vm.mode == 'edit' ? {} : {
    click: function () {
      return _vm.isOpen = true;
    }
  }), [_vm.didResize ? [(_vm$order2 = _vm.order) !== null && _vm$order2 !== void 0 && (_vm$order2$skin = _vm$order2.skin) !== null && _vm$order2$skin !== void 0 && _vm$order2$skin.open_effect ? _c('confetti', {
    key: _vm.order.skin.open_effect,
    staticClass: "absolute-fill overflow-hidden",
    staticStyle: {
      "z-index": "2"
    },
    attrs: {
      "effect": _vm.order.skin.open_effect,
      "active": !_vm.isOpen && !_vm.isConfettiLoading
    }
  }) : _vm._e(), _c('card-background', {
    attrs: {
      "src": _vm.order.skin.page_background_img
    }
  }), _c('div', {
    staticClass: "header d-flex align-start pa-1 absolute",
    attrs: {
      "role": "navigation",
      "aria-label": "Site navigation"
    }
  }, [_vm.order.skin.header_logo ? _c('div', {
    staticClass: "flex-grow-0 fill-height relative"
  }, [_c('img', {
    staticClass: "absolute",
    attrs: {
      "height": "100%",
      "aria-hidden": "true",
      "src": _vm.order.skin.header_logo
    }
  })]) : _vm._e(), _c('v-spacer'), _vm.order.allow_open_edit && !_vm.preview ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "aria-label": "Sign / edit",
      "fab": "",
      "small": "",
      "color": _vm.mode == 'edit' || !_vm.order.updated_at ? 'primary' : null,
      "loading": _vm.toggleModeStatus.pending || _vm.saveStatus.pending
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggleMode.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mode == 'edit' ? _vm.mdiCheck : _vm.mdiPencil)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v(" " + _vm._s(_vm.mode == 'edit' ? 'Save changes' : 'Sign / edit…') + " ")]), !_vm.hideTips && !_vm.order.updated_at && !_vm.didChangeMode ? _c('div', {
    staticClass: "btn-tooltip btn-tooltip-prominent bottom elevation-20 persistent pa-0",
    staticStyle: {
      "width": "200px",
      "text-wrap": "wrap",
      "z-index": "100"
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("Click here to personalize this envelope and card")]), _c('v-divider'), _c('v-btn', {
    staticClass: "fill-width",
    attrs: {
      "text": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.hideTips = true;
      }
    }
  }, [_vm._v("Hide tips")])], 1) : _vm._e()], 1) : _vm._e(), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "fab": "",
      "small": "",
      "aria-label": _vm.envBtnMsg,
      "loading": !!_vm.envLoadingState
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return function () {
          _vm.didClickEnv = true;
          if (!_vm.envLoadingState) _vm.isOpen = !_vm.isOpen;
        }.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.isOpen ? _vm.mdiEmail : _vm.mdiEmailOpen)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v(_vm._s(_vm.envBtnMsg))]), !_vm.hideTips && !_vm.order.updated_at && !_vm.didClickEnv && _vm.didChangeMode ? _c('div', {
    staticClass: "btn-tooltip btn-tooltip-prominent bottom elevation-20 persistent pa-0",
    staticStyle: {
      "width": "200px",
      "text-wrap": "wrap"
    }
  }, [_c('div', {
    staticClass: "pa-3"
  }, [_vm._v("Click here to switch between the envelope view and the card view")]), _c('v-divider'), _c('v-btn', {
    staticClass: "fill-width",
    attrs: {
      "text": "",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        _vm.hideTips = true;
      }
    }
  }, [_vm._v("Hide tips")])], 1) : _vm._e()], 1), _vm.giftcardBlobs.length ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "aria-label": "Gift cards",
      "fab": "",
      "small": ""
    },
    on: {
      "click": function ($event) {
        _vm.showGiftcards = true;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiWalletGiftcard)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Gift cards…")])], 1) : _vm._e(), !_vm.isStandaloneGroupVideo ? _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "aria-label": "Print",
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.tryPrint
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPrinter)
    }
  }), _c('span', {
    staticClass: "btn-tooltip bottom"
  }, [_vm._v("Print")])], 1) : _vm._e(), _c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "height": "40",
      "color": "primary",
      "elevation": "5",
      "rounded": "",
      "disabled": _vm.mode == 'edit'
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.close(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.doneBtnName || (_vm.preview ? 'Exit preview' : 'Done')) + " ")])], 1), _c('div', {
    staticClass: "flex-grow-1 relative"
  }, [_vm.editable ? _c('order-stepper-theme', {
    staticClass: "absolute-fill",
    staticStyle: {
      "min-height": "480px",
      "transition": "opacity .2s",
      "z-index": "1",
      "top": "73px"
    },
    style: {
      opacity: _vm.mode == 'edit' && _vm.state == 'closed' ? 1 : 0
    },
    attrs: {
      "order": Object.assign({}, _vm.order, {
        skin: Object.assign({}, _vm.order.skin, {
          header_logo: null
        })
      }),
      "org-skin": _vm.loadedOrgSkin,
      "no-step-to": true,
      "hide-background-confetti": true,
      "edit-to": true,
      "edit-from": true
    },
    on: {
      "update-info": _vm.updateToFrom,
      "input": _vm.updateSkin
    }
  }) : _vm._e(), _vm.editable && _vm.state == 'open' ? _c('div', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "1"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "env-container absolute-fill pa-3",
    class: _vm.state,
    style: {
      top: _vm.absHeader ? null : '73px',
      opacity: _vm.mode == 'edit' ? '0 !important' : null,
      'pointer-events': _vm.mode == 'edit' ? 'none' : null
    }
  }, [_c('envelope', {
    ref: "env",
    staticClass: "fill-height",
    attrs: {
      "offset-controls": _vm.isStandaloneGroupVideo ? _vm.isInvitation ? 104 : 0 : 68,
      "skin": _vm.order.skin,
      "from": _vm.order.info.from,
      "to": _vm.order.info.to,
      "aspect-ratio": _vm.isStandaloneGroupVideo ? 16 / 9 : 5 / 7,
      "contents-width": _vm.isStandaloneGroupVideo ? 800 : null
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var w = _ref.w;
        return [_vm.isStandaloneGroupVideo ? _c('v-card', {
          attrs: {
            "color": "black"
          }
        }, [_c('v-responsive', {
          staticClass: "d-flex text-center align-center",
          attrs: {
            "aspect-ratio": 16 / 9
          }
        }, [_c('v-btn', {
          attrs: {
            "fab": "",
            "x-large": "",
            "color": "primary"
          }
        }, [_c('v-icon', {
          attrs: {
            "x-large": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPlay)
          }
        })], 1)], 1)], 1) : _c('card-preview', {
          staticClass: "v-card v-sheet",
          attrs: {
            "mode": "view",
            "card": _vm.cover,
            "is-card-owner": _vm.isOwner,
            "is-verified-recipient": _vm.isVerifiedRecipient,
            "width": w
          }
        })];
      }
    }], null, false, 2250406196)
  })], 1), _vm.order.skin.music && _vm.mode == 'view' ? [_c('audio', {
    ref: "music",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.order.skin.music,
      "loop": ""
    },
    on: {
      "pause": function ($event) {
        _vm.isMusicPlaying = false;
      }
    }
  }), _c('v-fade-transition', [!_vm.didOpen ? _c('div', {
    staticClass: "absolute d-flex justify-center pa-3",
    staticStyle: {
      "bottom": "0",
      "width": "100%",
      "z-index": "4",
      "pointer-events": "none"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "height": "56",
      "elevation": "3",
      "color": "primary",
      "rounded": ""
    },
    on: {
      "click": function ($event) {
        _vm.isOpen = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMusic)
    }
  }), _vm._v(" Click to open ")], 1)], 1) : _vm._e()]), _c('v-fade-transition', [_vm.didOpen ? _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "absolute",
    class: {
      pulse: _vm.isMusicPlaying
    },
    staticStyle: {
      "bottom": "12px",
      "right": "12px",
      "z-index": "4"
    },
    attrs: {
      "fab": "",
      "height": "56",
      "elevation": "3",
      "loading": _vm.isMusicLoading
    },
    on: {
      "!click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleMusic.apply(null, arguments);
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.isMusicPlaying ? 'primary' : 'warning'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.isMusicPlaying ? _vm.mdiMusic : _vm.mdiMusicOff)
    }
  })], 1) : _vm._e()], 1)] : _vm._e(), _vm.isStandaloneGroupVideo ? _c('div', {
    staticClass: "video absolute-fill d-flex flex-column justify-center align-center pa-3",
    class: _vm.state
  }, [_c('group-video-playback', {
    staticStyle: {
      "width": "800px",
      "max-width": "100%"
    },
    attrs: {
      "value": "",
      "mode": "open",
      "project-id": _vm.groupVideoProjectId
    },
    on: {
      "slow-playback": _vm.onSlowPlayback,
      "play-video": _vm.pauseMusic
    }
  }), _vm.isInvitation ? _c('div', {
    staticClass: "d-flex justify-center align-center",
    staticStyle: {
      "height": "104px"
    }
  }, [_c('rsvp-btn', {
    attrs: {
      "pulse": !_vm.didClickRSVP
    },
    on: {
      "click": function ($event) {
        _vm.didClickRSVP = true;
        _vm.showRSVP = true;
      }
    }
  })], 1) : _vm._e()], 1) : _c('card-editor', {
    ref: "card-editor",
    staticClass: "card overflow-hidden",
    class: [_vm.state, _vm.mode],
    style: {
      'padding-top': _vm.absHeader ? 0 : '73px'
    },
    attrs: {
      "order-id": _vm.readToken,
      "mode": _vm.mode,
      "card": _vm.order,
      "is-owner": _vm.isOwner || _vm.order.allow_universal_editing,
      "is-verified-recipient": _vm.isVerifiedRecipient,
      "grid-padding": 73,
      "ctrl-padding-right": _vm.order.skin.music && _vm.$vuetify.breakpoint.xsOnly && _vm.mode == 'view' ? 68 : 0,
      "allow-replace-design": _vm.order.allow_replace_design
    },
    on: {
      "click-group-video": function ($event) {
        _vm.showGroupVideo = true;
      },
      "click-giftcard": function (x) {
        return _vm.showGiftcardBlob = x;
      },
      "click-rsvp": function ($event) {
        _vm.showRSVP = true;
      },
      "page-group-video": function () {
        if (!_vm.didShowGroupVideo) _vm.showGroupVideo = true;
      },
      "play-video": _vm.pauseMusic,
      "reload": function ($event) {
        return _vm.load(true);
      },
      "input": function ($event) {
        _vm.dirty = true;
        _vm.enqueueSave(3000);
      },
      "save": _vm.save
    }
  })], 2)] : _vm._e()], 2) : _vm.notFound && !_vm.isRedirecting ? _c('v-sheet', {
    staticClass: "fill-height d-flex flex-column justify-center align-center pa-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Card not found")]), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "to": {
        name: 'start'
      }
    }
  }, [_vm._v("Home")]), _c('v-btn', {
    staticClass: "mt-8",
    attrs: {
      "to": {
        name: 'catalog'
      }
    }
  }, [_vm._v("Browse cards")]), _c('div', {
    staticClass: "mt-8 text-center"
  }, [_vm._v(" Think you're seeing this page in error? Please let us know!"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@ellacard.com"
    }
  }, [_vm._v("support@ellacard.com")])])], 1) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }